package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.di.koinGet
import io.horion.cv.styles.PersonalFormFullWidthStyle
import io.horion.cv.styles.PersonalFormGroupColumnStyle
import io.horion.cv.styles.PersonalFormMainColumnStyle

@Composable
fun ContentForm() {

    val letterViewModel = koinGet<LetterViewModel>()
    val letterUiState = letterViewModel.letterUiState

    Column(
        modifier = PersonalFormMainColumnStyle.toModifier()
    ) {
        Column(
            modifier = PersonalFormGroupColumnStyle.toModifier()
        ) {
            // Objet
            TextFormField(
                label = "Objet",
                value = letterUiState.data.subject,
                onValueChange = { value ->
                    letterViewModel.updateObjet(objet = value)
                },
                modifier = PersonalFormFullWidthStyle.toModifier()
            )

            // Date
            FormFieldIcon(
                label = "Date",
                value = letterViewModel.getFormattedDate(),
                onValueChanged = { value ->
                    letterViewModel.updateDate(date = value)
                },
                modifier = PersonalFormFullWidthStyle.toModifier()
            )
        }

        // Introduction
        RichTextDescription(
            label = "Introduction",
            value = letterUiState.data.introduction,
            onValueChange = { html ->
                letterViewModel.updateIntroduction(html)
            },
            modifier = PersonalFormFullWidthStyle.toModifier()
        )
    }
}